export default function ErrorFallback({ errorMessage }: { errorMessage: Error }) {
  const { message } = errorMessage;
  return (
    <div role="alert" aria-live="polite">
      <p className="px-4 text-piptext-error">
        {message || 'An error occurred'}
      </p>
    </div>
  );
}
